export default __webpack_public_path__ + "static/media/higher_brand_arrow_right_white.d540cb8d.svg";